export const administrationAccountsSiteLocationLicences = {
    template: require('./administration-accounts-site-location-licences.html'),
    controller: 'AdministrationAccountsSiteLocationLicencesController'
};
